import { Component, OnInit, ViewChild } from '@angular/core';
import { NzModalRef, NzMessageService, NzFormatEmitEvent, NzTreeNode } from 'ng-zorro-antd';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Observable, Observer} from 'rxjs';
import {AppsService, UserService} from "@ecip/service";

@Component({
  selector: 'app-user-local-app',
  templateUrl: './user.app.component.html'
})
export class UserLocalAppComponent implements OnInit {
  record: any = {};
  i: any;
  form: FormGroup;
  appList: any = [];
  loading: boolean = false;

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    public appsService: AppsService,
    public userService: UserService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      appIds: [null, []]
    });
    this.loading = true;
    Observable.forkJoin([this.appsService.getList(),
      this.userService.findAppIds(this.record.id)]).subscribe(([appList, appIds]) => {
      this.appList = appList;
      this.form.get('appIds').setValue(appIds);
      this.loading = false;
    });
  }

  submit() {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) return;
    //ä¿®æ¹
    this.userService.saveApp(this.record.id, this.form.get('appIds').value).subscribe(res => {
      this.msgSrv.success('ä¿å­æå');
      this.modal.close(true);
    });
  }

  close() {
    this.modal.destroy();
  }
}
